// import "./App.css";
// import { useState } from "react";
// import { BrowserRouter, Route, Routes } from "react-router-dom";
// import Home from "./pages/Home";
// import Header from "./Components/Header";
// import Register from "./pages/Register";
// import Login from "./pages/Login";
// import Footer from "./Components/footer";
// import Households from "./pages/Households";
// import Electronics from "./pages/Electronics";
// import Furnitures from "./pages/furnitures";
// import Contacts from "./pages/Contacts";
// import AboutPage from "./pages/About_Us";
// import Description from "./Components/Description";
// import Myproducts from "./pages/Myproducts";
// import Addproduct from "./pages/AddProduct";
// import ProfilePage from "./pages/ProfilePage";
// import Update from "./Components/update";
// import PaymentComponent from "./Components/proceedPay";
// import OrderComponent from "./Components/order";
// import SellerOrders from "./pages/myorders";
// import TermsAndConditionsPage from "./pages/TermsAndConditions";
// import Admin from "./Components/TestingAdmin";

// function App() {
//   const [cartItems, setCartItems] = useState([]);
//   const handleAddToCart = (item) => {
//     setCartItems((prevItems) => [...prevItems, item]);
//   };
//   const handleRemoveFromCart = (index) => {
//     setCartItems((prevItems) => {
//       const newItems = [...prevItems];
//       newItems.splice(index, 1);
//       return newItems;
//     });
//   };

//   return (
//     <BrowserRouter>
//       <Header
//         cartItems={cartItems}
//         handleRemoveFromCart={handleRemoveFromCart}
//       />
//       <div className="overflow-hidden">
//         <p className="moving-text hidden md:block">
//           Introducing our website prototype! Explore our features and provide
//           feedback. Contact us via WhatsApp at 0729144533 for inquiries and
//           suggestions. Enjoy!
//         </p>
//         <p className="moving-text md:hidden">
//           Introducing our website prototype! Explore, provide feedback, and
//           enjoy.
//         </p>
//       </div>
//       <Routes>
//         <Route>
//           <Route path="/" element={<Home />} />
//           <Route path="/Home" element={<Home />} />
//           <Route path="/households" element={<Households />} />
//           <Route path="/furniture" element={<Furnitures />} />
//           <Route path="/electronics" element={<Electronics />} />
//           <Route path="/myproducts" element={<Myproducts />} />
//           <Route path="/addproducts" element={<Addproduct />} />
//           <Route path="/Update/:id" element={<Update />} />
//           <Route path="/profile" element={<ProfilePage />} />
//           <Route path="/pay" element={<PaymentComponent />} />
//           <Route path="/order" element={<OrderComponent />} />
//           <Route path="/order/myorders" element={<SellerOrders />} />
//           <Route path="/Admin" element={<Admin />} />

//           <Route
//             path="/desc/:id"
//             element={<Description handleAddToCart={handleAddToCart} />}
//           />
//           <Route path="/about" element={<AboutPage />} />
//           <Route path="/termsofuse" element={<TermsAndConditionsPage />} />
//           <Route path="/contacts" element={<Contacts />} />
//           <Route path="/Register" element={<Register />} />
//           <Route path="/login" element={<Login />} />
//         </Route>
//       </Routes>
//       <Footer />
//     </BrowserRouter>
//   );
// }

// export default App;


import "./App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Header from "./Components/Header";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Footer from "./Components/footer";
import Households from "./pages/Households";
import Electronics from "./pages/Electronics";
import Furnitures from "./pages/furnitures";
import Others from "./pages/OtherProducts";
import Contacts from "./pages/Contacts";
import AboutPage from "./pages/About_Us";
import Description from "./Components/Description";
import Myproducts from "./pages/Myproducts";
import Addproduct from "./pages/AddProduct";
import ProfilePage from "./pages/ProfilePage";
import Update from "./Components/update";
import PaymentComponent from "./Apis/proceedPay";
import OrderComponent from "./Components/order";
import SellerOrders from "./pages/myorders";
import BuyerOrders from "./pages/BuyersOrder";
import TermsAndConditionsPage from "./pages/TermsAndConditions";
import Admin from "./Components/TestingAdmin";
import EmailVerification from "./Auth/EmailVerification";
import PasswordReset from "./Auth/passwordReset";
import ResetPassword from "./Auth/ResetPasswordForm";
import FAQ from "./Components/faq";
import Testimonials from "./Components/Testimonials";
function RoutesWrapper() {
  const [cartItems, setCartItems] = useState(() => {
    const storedItems = localStorage.getItem('cartItems');
    return storedItems ? JSON.parse(storedItems) : [];
  });
  const handleAddToCart = (item) => {
    setCartItems((prevItems) => [...prevItems, item]);
  };
  const handleRemoveFromCart = (index) => {
    setCartItems((prevItems) => {
      const newItems = [...prevItems];
      newItems.splice(index, 1);
      return newItems;
    });
  };
  const handleRemoveAllFromCart = () => {
    setCartItems([])
  };

  const location = useLocation();
  const hideHeader = location.pathname === "/admin" || location.pathname === "/Admin/addproducts" || location.pathname === "/Admin/myproducts";

  return (
    <>
      {!hideHeader && (
        <Header
          cartItems={cartItems}
          handleRemoveFromCart={handleRemoveFromCart}
          handleRemoveAllFromCart={handleRemoveAllFromCart}
        />
      )}
      <div className="overflow-hidden">
        {/* <p className="moving-text hidden md:block">
          Introducing our website prototype! Explore our features and provide
          feedback. Contact us via WhatsApp at 0729144533 for inquiries and
          suggestions. Enjoy!
        </p>
        <p className="moving-text md:hidden">
          Introducing our website prototype! Explore, provide feedback, and
          enjoy.
        </p> */}
      </div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Home" element={<Home />} />
        <Route path="/households" element={<Households />} />
        <Route path="/furniture" element={<Furnitures />} />
        <Route path="/electronics" element={<Electronics />} />
        <Route path="/others" element={<Others />} />
        <Route path="/Admin/myproducts" element={<Myproducts />} />
        <Route path="/Admin/addproducts" element={<Addproduct />} />
        <Route path="/Admin/Update/:id" element={<Update />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/pay" element={<PaymentComponent />} />
        <Route path="/order" element={<OrderComponent />} />
        <Route path="/order/client" element={<SellerOrders />} />
        <Route path="/order/myorders" element={<BuyerOrders />} />
        <Route path="/Admin" element={<Admin />} />
        <Route path="/password_reset" element={<PasswordReset />} />
        <Route path="/auth/account/verify/:token" element={<EmailVerification />} />
        <Route path="/auth/account/reset_password/:token" element={<ResetPassword />} />
        <Route
          path="/desc/:id"
          element={<Description handleAddToCart={handleAddToCart} />}
        />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/termsofuse" element={<TermsAndConditionsPage />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/Register" element={<Register />} />
        <Route path="/login" element={<Login />} />
      </Routes>
      {/* <FAQ />
      <Testimonials /> */}
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <RoutesWrapper />
    </BrowserRouter>
  );
}

export default App;

